export enum TechType {
  FRONTEND = 'FRONTEND',
  BACKEND = 'BACKEND',
  DATABASE = 'DATABASE',
  OTHER = 'OTHER',
}
export interface Technology {
  name: string;
  type: TechType;
  proficiency: number; // Optional, can be used to indicate skill level
}

export interface Experience {
  id: string;
  title: string;
  company: string;

  startDate: string;
  endDate: string | null;

  icon: string;
  iconBg: string;

  achievements: string[];
  technologies?: Technology[];
}
